export default "__VITE_ASSET__DqkgPjjC__"